// ABOUTME: Builds custom list definitions consumed by the applicant schedule modal.
// ABOUTME: Loads candidate jobs and recipients used when creating Agenda events.
import { useApiCache } from "customHooks/useApi";
import useApplicantViewContext from "Pages/Applicant/ApplicantView/useApplicantViewContext";
import React, { useReducer } from "react";
import {
    buildJobListDefinition,
    buildRecipientListDefinition
} from "./scheduleListHelpers";

const reducer = (
    state: Compleo.CustomLists.ListDefinitionType[],
    action: Compleo.CustomLists.ListDefinitionType
) => {
    const newState = state.filter(
        (item) => item.fieldName !== action.fieldName
    );
    newState.push(action);
    return newState;
};

const verifyReady = (
    fieldList: string[],
    state: Compleo.CustomLists.ListDefinitionType[]
) => {
    const currentFieldsLoaded = state.map((item) => item.fieldName);
    for (const field of fieldList) {
        if (!currentFieldsLoaded.includes(field)) {
            return false;
        }
    }
    return true;
};

const useModalNewScheduleLists: (
    t: any,
    readyTranslation: boolean
) => [Compleo.CustomLists.ListDefinitionType[], boolean] = (
    t: any,
    readyTranslation: boolean
) => {
    const [data] = useApplicantViewContext();
    const { applicantData } = data;
    const [listDefinition, dispatch] = useReducer(reducer, []);
    const applicantEmail = applicantData?.email;

    const jobs = applicantData?.Jobs || [];
    React.useEffect(() => {
        dispatch(buildJobListDefinition(jobs));
    }, [jobs.length]);

    // /user/dropdownlist
    const [listResult, getList] = useApiCache(
        "/user/dropdownlist",
        "post",
        {
            companyId: data.companyId
        },
        false,
        60 * 1000 * 10
    );
    const userList = listResult.response?.data || [];

    React.useEffect(() => {
        if (readyTranslation) {
            dispatch(
                buildRecipientListDefinition({
                    applicantEmail,
                    t,
                    userList
                })
            );
        }
        // console.log("userList", userList);
    }, [applicantEmail, userList.length, readyTranslation]);
    // const ready = verifyReady(["job", "recipientes"], listDefinition);
    const ready = verifyReady(["job", "recipients"], listDefinition);
    // console.log("listDefinition", listDefinition);
    return [listDefinition, ready];
};

export default useModalNewScheduleLists;
